import styled from "styled-components"

export const MLabel = styled.label`
    font-size: 0.9rem;
    color: #6c757d;
`
export const Title = styled.span`
    color:var(--morienGreen);
    font-size: 1rem;
    font-weight:bold;
`

export const Line = styled.div`
`
export const ButtonInput = styled.button`
    margin-left:3px;
    padding: 2px 10px;
    font-size: 1rem;
    border:1px solid transparent;
    border-color: var(--morienGreen);
    border-radius: 5px;
    background-color: var(--morienGreen);
    color: white;
    cursor: pointer;
    :active{
        background-color: #32cd32;            
    }
`

export const GoodsImg = styled.img`
    padding-top: 2px;
    padding-left: 2px;
    max-width: 45px;
`;